const INSERT_ANCHOR = '/barang'

const OPERASIONAL_ROUTES = [
  '/penerimaan-barang',
  '/penempatan',
  '/stock-in',
  '/stock-opname',
  '/pengembalian',
  '/retur-konsumen',
]

const AJUAN_ROUTES = [
  '/ajuanbarang',
  '/biaya-operasional',
  '/pengambilan-barang',
]

const ALL_GROUP_ROUTES = new Set([...OPERASIONAL_ROUTES, ...AJUAN_ROUTES])

function getRoute(item) {
  return item?.route || item?.url || null
}

function getMenuItemKey(item) {
  return getRoute(item) || item.header || item.title
}

function collectReservedRoutes(menus) {
  const reserved = new Set()
  menus.forEach(item => {
    if (!item.children?.length) return
    item.children.forEach(child => {
      const route = getRoute(child)
      if (route) reserved.add(route)
    })
  })
  return reserved
}

function indexFlatItems(menus) {
  const map = new Map()
  menus.forEach(item => {
    if (item.children?.length) return
    const route = getRoute(item)
    if (!route) return
    if (map.has(route)) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn(`[groupAdminGudangMenus] duplicate flat route ignored: ${route}`)
      }
      return
    }
    map.set(route, item)
  })
  return map
}

function pickChildren(routes, flatIndex, reservedRoutes, usedRoutes) {
  const children = []
  routes.forEach(route => {
    if (reservedRoutes.has(route) || usedRoutes.has(route)) return
    const item = flatIndex.get(route)
    if (!item) return
    usedRoutes.add(route)
    children.push({
      ...item,
      key: getMenuItemKey(item),
    })
  })
  return children
}

function buildGroup(title, icon, children) {
  const tag = children.reduce((sum, child) => sum + (parseInt(child.tag, 10) || 0), 0)
  return {
    title,
    icon,
    children,
    key: title,
    ...(tag > 0 ? { tag } : {}),
  }
}

const CREATED_GROUP_TITLES = new Set(['Operasional Stok', 'Ajuan'])

function dedupeMenuTree(menus) {
  const seen = new Set()
  const result = []

  menus.forEach(item => {
    if (item.children?.length) {
      // Jangan sentuh children grup asli dari API (Disposal, Gudang, dll.)
      if (!CREATED_GROUP_TITLES.has(item.title)) {
        item.children.forEach(child => {
          const route = getRoute(child)
          if (route) seen.add(route)
        })
        result.push(item)
        return
      }

      const children = []
      item.children.forEach(child => {
        const route = getRoute(child)
        if (route && seen.has(route)) return
        if (route) seen.add(route)
        children.push(child)
      })
      if (children.length > 0) {
        result.push({ ...item, children })
      }
      return
    }

    const route = getRoute(item)
    if (route && seen.has(route)) return
    if (route) seen.add(route)
    result.push(item)
  })

  return result
}

export default function groupAdminGudangMenus(menus) {
  if (!Array.isArray(menus) || menus.length === 0) {
    return menus
  }

  const reservedRoutes = collectReservedRoutes(menus)
  const flatIndex = indexFlatItems(menus)
  const usedRoutes = new Set()

  const operasionalChildren = pickChildren(
    OPERASIONAL_ROUTES,
    flatIndex,
    reservedRoutes,
    usedRoutes,
  )
  const ajuanChildren = pickChildren(
    AJUAN_ROUTES,
    flatIndex,
    reservedRoutes,
    usedRoutes,
  )

  const groups = []
  if (operasionalChildren.length > 0) {
    groups.push(buildGroup('Operasional Stok', 'PackageIcon', operasionalChildren))
  }
  if (ajuanChildren.length > 0) {
    groups.push(buildGroup('Ajuan', 'FileTextIcon', ajuanChildren))
  }

  if (groups.length === 0) {
    return menus
  }

  let groupsInserted = false
  const output = []

  const insertGroups = () => {
    if (groupsInserted) return
    groups.forEach(group => output.push(group))
    groupsInserted = true
  }

  menus.forEach(item => {
    const route = getRoute(item)

    if (!groupsInserted) {
      const isAnchor = route === INSERT_ANCHOR
      const isFirstGroupedFlat = !item.children?.length && route && ALL_GROUP_ROUTES.has(route)
      if (isAnchor || isFirstGroupedFlat) {
        insertGroups()
      }
    }

    if (item.children?.length) {
      output.push(item)
      return
    }

    if (route && usedRoutes.has(route)) {
      return
    }

    output.push(item)
  })

  if (!groupsInserted) {
    groups.forEach(group => output.push(group))
  }

  return dedupeMenuTree(output)
}
